<app-breadcrumb *ngIf="!commissionRedirection" master="Rozliczenia" parentName="Przepięcia polis" name="Dodaj"></app-breadcrumb>
<div class="commission-redirection-add-container" [formGroup]="commissionRedirectionForm" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()" [class.spinner]="processingRequest" [disabled]="processingRequest || !commissionRedirectionFormValid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane polisy</h3>
            </div>

            <div fxLayout="row">
              <app-dict-insurance-companies
                fxFlex="100" label="TU" [required]="true"
                [control]="insuranceCompanyControl"
                [hideChildren]="true"
              ></app-dict-insurance-companies>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-dict
                  [label]="'Firma'" [dictType]="'company'"
                  [control]="companyControl"
                  [required]="true"
                  [multiple]="false"
                ></app-dict>
              </div>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-dict-ofwcas fxFlex="100" label="OFWCA" [control]="ofwcaControl" [required]="true"></app-dict-ofwcas>
              </div>
            </div>

            <div fxLayout="row">
              <mat-slide-toggle fxFlex="100" color="accent" formControlName="externalOfwca">Zewnętrzna OFWCA (np. z TU)</mat-slide-toggle>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-form-field
                  fxFlex="100"
                >
                  <mat-label>Numer polisy</mat-label>
                  <input matInput placeholder="Dla Link4 np. &quot;K123456789_&quot;" formControlName="policyNumber" [required]="true">
                  <mat-error *ngIf="policyNumberControl.hasError('required')">To pole jest wymagane</mat-error>
                  <mat-error *ngIf="policyNumberControl.hasError('backendError')">Ten nr polisy już istnieje</mat-error>
                </mat-form-field>
              </div>

              <div fxFlex="50">
                <mat-form-field
                  fxFlex="100"
                >
                  <mat-label>Nazwa klienta</mat-label>
                  <input matInput placeholder="Np. &quot;ASF Premium%&quot;" formControlName="customerName" [required]="withoutPolicyNumberControl.value">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-slide-toggle fxFlex="100" color="accent" formControlName="withoutPolicyNumber">Brak numeru polisy</mat-slide-toggle>
              </div>
              <div fxFlex="50">
                <mat-slide-toggle fxFlex="100" color="accent" [formControl]="proportionalCommissionControl">Proporcjonalna prowizja</mat-slide-toggle>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <app-datepicker
                fxFlex="50"
                label="Data zawarcia"
                placeholder="2000-01-01"
                [required]="false"
                [control]="concludeDateControl"
              ></app-datepicker>
              <mat-form-field fxFlex="50">
                <mat-label>Przypis</mat-label>
                <input [required]="true" type="number" matInput placeholder="Kwota" [formControl]="assignControl">
                <mat-error *ngIf="assignControl.hasError('required')">To pole jest wymagane</mat-error>
              </mat-form-field>

            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Uzupełnianie numeru polisy oraz nazwy klienta</h3>
            </div>

            <div fxLayout="column">
              <p>
                Znak "%" reprezentuje zero, jeden lub wiele dowonlnych znaków.
              </p>
              <h4 class="small-margin-header">Przepinanie polisy wraz ze wznowieniami:</h4>
              <ul>
                <li>Link 4: zamiast ostatniego znaku (nr wznowienia) znak "%", np. zamiast K1234567890 wpisujemy K123456789% (usuwamy ostatni znak i w jego miejsce wpisujemy "%")</li>
                <li>PZU: zamiast pełnego numeru polisy podajemy znaki do "-", np. zamiast 123456789-1 wpisujemy 123456789% </li>
                <li>InterRisk: zamiast pełnego numeru polisy podajemy znaki do "-", np. zamiast KM-H/P0123456-A wpisujemy KM-H/P0123456%</li>
              </ul>
            </div>

            <div fxLayout="column">
              <h4 class="small-margin-header">Zasady przepinania polis:</h4>
              <ul>
                <li>
                  Jeśli dla danego nr polisy zostało już utworzone przepięcie należy edytować to, które jest w bazie. Nie ma możliwości wpisania kilku przepięć do tego samego nr polisy.
                </li>
                <li>
                  Jeśli polisa została wystawiona przez OFWCA ASF, to wymagane jest poprawne wskazanie OFWCA z bazy systemu.
                </li>
                <li>
                  Jeśli polisa została wystawiona przez OFWCA nieistniejącą w bazie systemu, to wymagane jest zaznaczenie pola "Zewnętrzna OFWCA (np. z TU)".
                </li>
                <li>
                  Zamiast "ASF Premium sp. z o.o." jako nazwę klienta podajemy "ASF Premium%". Dzięki temu rekord prowizji, dla którego nazwa klienta to np. "ASF Premium spółka z o.o." także zostanie przepięty.
                </li>
              </ul>
            </div>

          </mat-card>
        </div>
      </div>
    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Na kogo przepinamy</h3>
            </div>

            <div fxLayout="row">
              <mat-slide-toggle class="slide-padding" [formControl]="internalCommissionControl">Prowizja ASF</mat-slide-toggle>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-dict-ofwcas fxFlex="100" label="OFWCA" [control]="newOfwcaControl" [required]="true"></app-dict-ofwcas>
              </div>
            </div>

            <div fxLayout="row">
              <mat-slide-toggle class="slide-padding" [formControl]="showAllContractsControl">Pokaż wszystkie umowy</mat-slide-toggle>
            </div>

            <div fxLayout="row">
              <mat-slide-toggle class="slide-padding" [formControl]="crossCompanyControl">Pokaż umowy obu firm</mat-slide-toggle>
            </div>

            <div fxLayout="row" *ngIf="!showAllContractsControl.value">
              <div fxFlex="100">
                <app-dict-contracts
                  fxFlex="100" label="Umowa"
                  [control]="newContractControl" [required]="true"
                  [contracts]="controlContracts"
                  [initializeWith]="newContractControl.value"
                ></app-dict-contracts>
              </div>
            </div>

            <div fxLayout="row" *ngIf="showAllContractsControl.value">
              <div fxFlex="100">
                <app-dict-all-contracts
                  fxFlex="100" label="Umowa"
                  [control]="newContractControl" [required]="true"
                  [companyId]="(companyControl.value && !crossCompanyControl.value) ? companyControl.value : null"
                  [partnershipContracts]="true"
                ></app-dict-all-contracts>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>

            <table mat-table [dataSource]="dataSource" >

              <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->

              <!-- Position Column -->
              <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef>lp.</th>
                <td mat-cell *matCellDef="let element"> {{element.position}} </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>TU</th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="weight">
                <th mat-header-cell *matHeaderCellDef>Metodyka wprowadzania</th>
                <td mat-cell *matCellDef="let element"> {{element.weight}} </td>
              </ng-container>

              <!-- Symbol Column -->
              <ng-container matColumnDef="symbol">
                <th mat-header-cell *matHeaderCellDef>Przykładowe nr polis </th>
                <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns" ></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class]="row"></tr>
            </table>


          </mat-card>
        </div>
      </div>
    </div>

  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()" [class.spinner]="processingRequest" [disabled]="processingRequest || !commissionRedirectionFormValid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
